import { black, green, red, yellow } from 'globals/colors';
import { InvitationStatus } from 'globals/types';

export const getColor = (type: InvitationStatus): string => {
  switch (type) {
    case InvitationStatus.OPENED:
      return green.MAIN;
    case InvitationStatus.REJECTED:
      return red.MAIN;
    case InvitationStatus.SENT:
      return yellow.MAIN;
    default:
      return black;
  }
};
